import { hotList } from "@/mocks/home";

const toneMap: Record<string, string> = {
  hot: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  neutral: "bg-secondary-100 text-secondary-900",
};

export default function BreakingList() {
  return (
    <section id="hot" className="w-full bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="inline-flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-line text-sm" />
              </span>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">今日热榜</h2>
            </div>
            <p className="mt-2 font-body text-sm text-foreground-600">
              标题与短摘要，先读最快的判断；点进详情再深挖背后真相。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 self-start font-label text-xs text-foreground-500 sm:self-auto">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
            每 15 分钟刷新
          </span>
        </div>

        <ul className="mt-7 space-y-3">
          {hotList.map((item) => (
            <li key={item.id}>
              <a
                href="#resource"
                className="group flex flex-col gap-3 rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-primary-50/40 md:flex-row md:items-center md:gap-5 md:p-5"
              >
                <span className="w-8 shrink-0 font-heading text-2xl font-bold text-secondary-300 transition-colors group-hover:text-primary-400">
                  {String(item.id).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`whitespace-nowrap rounded-full px-2 py-0.5 font-label text-[11px] font-medium ${toneMap[item.tagTone]}`}>
                      {item.tag}
                    </span>
                    <span className="whitespace-nowrap font-label text-[11px] text-foreground-400">{item.views} 阅读</span>
                  </div>
                  <h3 className="mt-1.5 font-heading text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-2 font-body text-sm text-foreground-600">{item.summary}</p>
                </div>
                <div className="flex shrink-0 items-center gap-3 self-start md:flex-col md:items-end md:self-center">
                  <span className="whitespace-nowrap font-label text-xs text-foreground-400">{item.time}</span>
                  <i className="ri-arrow-right-line text-foreground-300 transition-all group-hover:translate-x-1 group-hover:text-primary-500" />
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}